export default{
    cardClass:function (name) {
        switch(name)
        {
        case '平安银行':
            return 'pinan';
        case '中国邮政储蓄银行':
            return 'youzheng';
        case '中国建设银行':
            return 'jianshe';
        case '中国光大银行':
            return 'guangda';
        case '中国工商银行':
            return 'gongshang';
        case '中国建设银行':
            return 'jianshe';
        case '浦发银行':
            return 'pufa';
        case '招商银行':
            return 'zhaoshang';
        case '广发银行':
            return 'guangfa';
        case '中国银行':
            return 'zhongguo';
        case '中信银行':
            return 'zhongxin';
        case '中国农业银行':
            return 'nongye';
        case '兴业银行':
            return 'xingye';
        case '交通银行':
            return 'jiaotong';
        case '中国民生银行':
            return 'minsheng';
        case '华夏银行':
            return 'huaxia';
        default:
            return 'common';
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/bankCard.js